import { useTranslation } from "react-i18next";

export const useTranslator = useTranslation;
